import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import styled from 'styled-components';
import img1 from './img1.jpg';
import img2 from './img2.jpg';
import img3 from './img3.jpg';


const ButtonControl = styled.div`
  display:flex;
  justify-content: space-between;
  align-items: center;
  background-color: gray;
`;

const Wrapper = styled.section`
  padding: 4em;
  background: papayawhip;
`;

const tutorialSteps = [
  {
    label: 'Cactus Country',
    imgPath:
    img1,
  },
  {
    label: 'Mornington Peninsula',
    imgPath:
    img2,
  },
  {
    label: 'Phillip Island',
    imgPath:
    img3,
  },
];

const styles = theme => ({
  root: {
    width: '100%',
    flexGrow: 1,
   
  },
  header: {
    position:'relative',
    left:'calc(50% - 400px)',
    width:'800px',
    marginBottom:'10px',
    marginTop:'10px',
    backgroundColor: theme.palette.background.default,
  },
  img: {
    height:'100%',
    width: '100%',
    marginLeft:'auto',
    marginRIght:'auto',
    maxWidth: 800,
    overflow: 'hidden',
  },
});

function getSteps() {
  return ['Select campaign settings', 'Create an ad group', 'Create an ad'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return 'Select campaign settings...';
    case 1:
      return 'What is an ad group anyways?';
    case 2:
      return 'This is the bit I really care about!';
    default:
      return 'Unknown step';
  }
}

class Steppers extends React.Component {
  state = {
    activeStep: 0,
    skipped: new Set(),
  };

  handleNext = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep + 1,
    }));
  };

  handleBack = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1,
    }));
  };

  handleStepChange = activeStep => {
    this.setState({ activeStep });
  };

  render() {
    const { classes, theme } = this.props;
    const { activeStep } = this.state;
    const maxSteps = tutorialSteps.length;

    return (
      <div className={classes.root}>
         
        <Paper square elevation={0} className={classes.header}>
        
        <ButtonControl >
          <Button size="small" onClick={this.handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button> 
           <Typography style={{color:'white'}}>{tutorialSteps[activeStep].label}</Typography>

           <Button size="small" onClick={this.handleNext} disabled={activeStep === maxSteps - 1}>
            Next
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          </ButtonControl>
        </Paper>

        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={this.handleStepChange}
          enableMouseEvents
          style={{marginBottom:'10px'}}
        >
          {tutorialSteps.map((step, index) => (
            <div>
              {Math.abs(activeStep - index) <= 2 ? (
                <img key={step.label} className={classes.img} src={step.imgPath} alt={step.label} />
              ) : null}
            </div>
          ))}
        </SwipeableViews>

        
      </div>
    );
  }
}

Steppers.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Steppers);

